import { render, staticRenderFns } from "./TokenProjectFields.vue?vue&type=template&id=1f5b42b6&scoped=true"
import script from "./TokenProjectFields.vue?vue&type=script&lang=js"
export * from "./TokenProjectFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b42b6",
  null
  
)

export default component.exports